module.exports = __webpack_public_path__ + "img/contact_us_img.ee5c3c8a.png";